import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import "./index.scss";
import { LoginForm } from "components/UI/organisms";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";

export const Login = () => {
  return (
    <div className="login-container">
      <ReactHelmetWithProvider>
        <title>Log In - GCX</title>
        <link
          rel="canonical"
          href={window.location.origin + INTERNAL_PATHS.USER_LOG_IN}
        />
      </ReactHelmetWithProvider>
      <h1 className="login-title">Log In</h1>
      <p className="signup-message">
        Don't have an account?{" "}
        <NavLink to={INTERNAL_PATHS.USER_SIGN_UP} className="login-anchor">
          Sign Up
        </NavLink>
      </p>

      <LoginForm />

      <NavLink to={INTERNAL_PATHS.RESET_PASSWORD} className="login-anchor">
        Forgot Password?
      </NavLink>
    </div>
  );
};
